import { createTheme } from '@mui/material/styles';

export const themesAndModes = (themeName, mode) => {
  console.log("themesAndModes", themeName,mode);
  if(theme?.[themeName] == null){
    return theme.default.light;
  }
  if(theme[themeName]?.[mode] == null){
    return Object.values(theme[themeName])[0];
  }
  return theme[themeName][mode];
}

export const checkMode = (themeName, mode) => {
  if(theme?.[themeName] == null){
    return "light";
  }
  if(theme[themeName]?.[mode] == null){
    return Object.keys(theme[themeName])[0];
  }
  return mode;
}

export const theme = {
  picote: {
    light: createTheme({
      brand: "picote",
      palette: {
        mode: 'light',
        primary: {
          main: '#d20630',
        },
        secondary: {
          main: '#d20630',
        },
        // warning: {
        //   main: '#d32f2f',
        // },
        // background: {
        //   default: '#242424',
        //   paper: '#f0eadf',
        //   light: "#ffffff"
        // },
        phonenumberTableRowBackground: {
          deleted: '#141414',
          notCheked: '#58156526',
          notValidated: '#8405052b',
          ok: '#7cff0314',
        }
      },
      typography: {
        h2: {
    //     color: '#d20630', //secondary.main
          textTransform: 'uppercase',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'normal',
          marginBottom: 10,
          fontFamily: '',
        },
        h4: {
          color: '#586E71',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'normal',
          marginBottom: 8,
        },
        fontFamily: [
          'Raleway', 
          'sans-serif',
        ].join(','),
      },
      '.tick text': {
        position: 'absolute !important',
        fontSize: '12px'
      },
      '.tick text:hover': {
        position: 'absolute !important',
        zIndex: '1000 !important',
        fontSize: '15px'
      },
    }),
    dark: createTheme({
      brand: "picote",
      palette: {
        mode: 'dark',
        primary: {
          main: '#d20630',
        },
        secondary: {
          main: '#c8baa1',
        },
        warning: {
          main: '#d32f2f',
        },
        background: {
          default: '#242424',
          //paper: '#f0eadf',
          light: "#eee"
        },
        phonenumberTableRowBackground: {
          deleted: '#141414',
          notCheked: '#58156526',
          notValidated: '#8405052b',
          ok: '#7cff0314',
        }
      },
      typography: {
        h2: {
          color: '#c8baa1', //secondary.main
          textTransform: 'uppercase',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'normal',
          marginBottom: 10,
          fontFamily: '',
        },
        h4: {
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'normal',
          marginBottom: 8,
        },
        fontFamily: [
          'Raleway', 
          'sans-serif',
        ].join(','),
      },
      '.tick text': {
        position: 'absolute !important',
        fontSize: '12px'
      },
      '.tick text:hover': {
        position: 'absolute !important',
        zIndex: '1000 !important',
        fontSize: '15px'
      }
    })
  },
  default: {
    light: createTheme({
      palette: {
        brand: 'default',
        mode: 'light',
        primary: {
          main: '#4d8dc1',
        },
        secondary: {
          main: '#4d8dc1',
        },
        phonenumberTableRowBackground: {
          deleted: '#141414',
          notCheked: '#58156526',
          notValidated: '#8405052b',
          ok: '#7cff0314',
        }
      },
      typography: {
        h2: {
          color: '#586E71',
          textTransform: 'uppercase',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'normal',
          marginBottom: 10,
          fontFamily: '',
        },
        h4: {
          color: '#586E71',
          textAlign: 'center',
          fontSize: '16px',
          fontWeight: 'normal',
          marginBottom: 8,
        },
      },
      '.tick text': {
        position: 'absolute !important',
        fontSize: '12px'
      },
      '.tick text:hover': {
        position: 'absolute !important',
        zIndex: '1000 !important',
        fontSize: '15px'
      },
    }),
  }
}

